import React from 'react'
import { Modal, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const HauloutHelpModal = ({ visible, onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL || ''
  const downloadPdfUrl = `${apiUrl}${apiUrl && !apiUrl.endsWith('/') ? '/' : ''}download_summary_pdf?module=haulout-dashboard`

  return (
    <Modal
      title={
        <div className='haulout-help-header'>
          <span className='haulout-help-header-title'>Haulout Dashboard Summary</span>
        </div>
      }
      open={visible}
      visible={visible}
      onCancel={onClose}
      centered
      footer={[
        <a key='download' href={downloadPdfUrl} download='Haulout Dashboard summary.pdf'>
          <Button type='primary' className='haulout-help-download-btn' icon={<DownloadOutlined />}>
            Download PDF
          </Button>
        </a>
      ]}
      width={780}
      className='custom-modal haulout-help-modal'
    >
      <div className='haulout-help-content'>
        <div className='haulout-help-card'>
          <div className='haulout-help-title'>Haulout Dashboard</div>
          <p>
            The Haulout Dashboard displays all shipments which are located in the defined <strong>Haulout Work Area Mapping</strong> locations from the System Parameters module. The shipments are sorted by time to departure, with the earliest departure appearing at the top of the table.
          </p>
        </div>

        <div className='haulout-help-card'>
          <div className='haulout-help-title'>Conditions to Add</div>
          <ul className='haulout-help-list'>
            <li>
              <strong>For the Haulout Work area</strong> &ndash; shipments are added once they are scanned to a location mapped in the Haulout work area mapping page. ULDs which are <em>&apos;Open&apos;</em> will not be displayed even if they are scanned at a mapped location.
            </li>
            <li>
              The shipment will reappear on the Dashboard if the HCS receives a gate change message and the shipment is now at a wrong gate.
            </li>
            <li>
              <strong>For the &apos;All&apos; work area</strong> &ndash; once a built-up ULD is closed it will appear on the &apos;All&apos; work area. This work area will display all shipments which have completed the build-up process at the buildup work area and are waiting to be moved to a haul out location. Shipments which have been marked as <em>&apos;Done&apos;</em> on the Buildup Dashboard will appear in the All work area.
            </li>
          </ul>
        </div>

        <div className='haulout-help-card'>
          <div className='haulout-help-title'>Conditions to Remove</div>
          <p>Data is removed from the dashboard in the following scenarios:</p>
          <ul className='haulout-help-list'>
            <li>If the shipment is moved to the correct gate location</li>
            <li>If the actual flight departure event is received by the HCS</li>
            <li>If the shipment is moved to a location not mapped to Haulout Area mapping</li>
          </ul>
        </div>

        <div className='haulout-help-card'>
          <div className='haulout-help-title'>Order By</div>
          <p>
            Data is sorted by the <strong>time to departure</strong> with the earliest departure being at the top of the table.
          </p>
        </div>

        <div className='haulout-help-card'>
          <div className='haulout-help-title'>Filters</div>
          <p>
            The list can be populated by work area defined in the Build-up work area mapping page. It can be filtered by type of equipment used, hours to departure (1 - 8), product, location or origin-destination of the shipment.
          </p>
        </div>

        <div className='haulout-help-card'>
          <div className='haulout-help-title'>Comments</div>
          <ul className='haulout-help-list'>
            <li>The haul out dashboard is driven by the location entered in the Haulout Work area mapping page.</li>
            <li>If a shipment is scanned at these locations then it will appear on the Dashboard.</li>
          </ul>

          <div className='haulout-help-highlight-container'>
            <div className='haulout-help-flight-box'>
              <div className='haulout-help-flight-header'>For wide-body flights:</div>
              <ul className='haulout-sub-list'>
                <li>
                  If departure time is less than 120 mins it will be highlighted in <span className='haulout-text-gold'>Yellow</span>
                </li>
                <li>
                  If departure time is less than 90 mins it will be highlighted in <span className='haulout-text-red'>Red</span>
                </li>
              </ul>
            </div>
            <div className='haulout-help-flight-box'>
              <div className='haulout-help-flight-header'>For narrow-body flights:</div>
              <ul className='haulout-sub-list'>
                <li>
                  If departure time is less than 90 mins it will be highlighted in <span className='haulout-text-gold'>Yellow</span>
                </li>
                <li>
                  If departure time is less than 60 mins it will be highlighted in <span className='haulout-text-red'>Red</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default HauloutHelpModal
